import * as React from "react";
import { cn } from "../utils/cn";
import { Heading, Mono, Text } from "../primitives/typography";

export interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    eyebrow?: string;
    title: string;
    description?: string;
    actions?: React.ReactNode;
}

const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
    ({ className, eyebrow, title, description, actions, ...props }, ref) => (
        <div ref={ref} className={cn("mb-6 flex items-start justify-between gap-4", className)} {...props}>
            <div className="flex flex-col gap-0.5">
                {eyebrow && (
                    <Mono size="xs" muted className="mb-1 tracking-widest uppercase">
                        {eyebrow}
                    </Mono>
                )}
                <Heading level={2}>{title}</Heading>
                {description && <Text muted>{description}</Text>}
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2 pt-1">{actions}</div>}
        </div>
    ),
);
SectionHeader.displayName = "SectionHeader";

export { SectionHeader };
